import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

import theme from '../../theme'

const StyledCard = styled.article`
  background: ${theme.palette.white};
  box-shadow: 0 2px 8px ${theme.colors.boxShadowColor};
  border-radius: 12px;
  width: 100%;

  ${props =>
    props.canBeHovered &&
    css`
      :hover {
        box-shadow: 0px 2px 20px ${theme.colors.boxShadowColor};
      }
    `}
`

StyledCard.propTypes = {
  canBeHovered: PropTypes.bool
}

StyledCard.defaultProps = {
  canBeHovered: false
}

export default StyledCard
